import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Order, OrderNote, OrderNoteRequest } from '@models/order';
import { User } from 'src/app/models/user';
import { OrderNotesService } from 'src/app/services/order.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'gob-note-form',
  templateUrl: './note-form.component.html',
  styleUrls: ['./note-form.component.css']
})
export class NoteFormComponent implements OnInit {
  @Output() readonly back: EventEmitter<boolean>=new EventEmitter<boolean>();
  @Output() readonly note: EventEmitter<OrderNoteRequest>=new EventEmitter<OrderNoteRequest>();
  @Input() order: Order;
  private _editNote: OrderNote | null = null;
  @Input()
  set editNote(note: OrderNote | null) {
    this._editNote = note;
    this.initRequest();
  }
  get editNote(): OrderNote | null {
    return this._editNote;
  }

  request: OrderNoteRequest;
  currentUser: User | null = null;
  newPrivateNote = '';

  constructor(
    private userServ: UserService,
    private notesSvc: OrderNotesService
  ) {
    this.currentUser = this.userServ.user;
  }

  ngOnInit(): void {
    this.initRequest();
  }

  initRequest(){
    this.request = new OrderNoteRequest();
    if (this.editNote) {
      this.request.note = this.editNote.id;
      this.request.content = this.editNote.content;
      this.request.type = this.editNote.type;
    } else {
      this.request.note = null;
      this.request.content = '';
      this.request.type = 'private';
    }
  }

  /**
   * Returns an array of private notes associated with the order.
   * @returns {OrderNote[]} An array of OrderNote objects, sorted by creation time.
   */
  getPrivateNotes(){
    return this.order?.notes.filter((c: OrderNote) => c.type == 'private');
  }

  /**
   * Returns an array of public notes associated with the order.
   * @returns {OrderNote[]} An array of OrderNote objects, sorted by creation time.
   */
  getPublicNotes(){
    return this.order?.notes.filter((c: OrderNote) => c.type == 'public');
  }

/**
 * Save a private note for an order.
 * If the note's content is empty, the function does nothing.
 * @param {any} form - The form containing the updated note.
 * @example
 * this.savePrivateNote({content: 'This is a new note'})
 * @returns {void} Nothing is returned.
 */
  savePrivateNote(form: any){
    const text = this.request.content?.trim();
    if(!text) return;

    this.note.emit(this.request);
    form.reset();
    this.editNote = null;
    this.initRequest();
  }

}
